import React from 'react'
import { ThemeProvider } from '@leshen/ui'

const Wrapper = ({ children, customTheme }) => {
  return <ThemeProvider theme={customTheme}>{children}</ThemeProvider>
}

export default Wrapper
